<template>
  <div class="about">
    <h1>Marketing Your Protospiel Event</h1>

    <p>Marketing anything is hard. Here are a few places you should advertise your Protospiel. When you post, include at these 3 pieces of info:</p>
    
    <ul>
    <li>Name of Event</li>
    <li>URL</li>
    <li>Date of Event</li>
    </ul>
    
    <h2>Event Calendars</h2>
    
    <ul>
    <li>Get on the calendar of all the gaming groups that are local to you on <a href="http://meetup.com">Meetup</a> and <a href="http://facebook.com">Facebook</a>.</li>
    <li>Create an event in the <a href="https://www.facebook.com/groups/2261144717/events/">Protospiel Calendar on Facebook</a>.</li>
    </ul>
    
    <h2>Post at least monthly</h2>
    
    <p>Lots of places, including:</p>
    
    <h3>Facebook</h3>
    
    <ul>
    <li><a href="https://www.facebook.com/groups/2261144717/">Protospiel</a></li>
    <li><a href="https://www.facebook.com/groups/BoardGamePlaytestersGuild/">Tabletop Playtesters Guild on Facebook</a></li>
    <li><a href="https://www.facebook.com/groups/GameDesignersGuild/">Card and Board Game Designers Group on Facebook</a></li>
    <li><a href="https://www.facebook.com/groups/Connews/">Gaming con News</a></li>
    </ul>
    
    <h3>Reddit</h3>
    
    <ul>
    <li><a href="https://www.reddit.com/r/tabletopgamedesign/">Tabletop Game Design Subreddit</a></li>
    <li><a href="https://www.reddit.com/r/IndieBoardGames/">Indie Board Games</a></li>
    <li><a href="https://www.reddit.com/r/BoardGameCons/">Board Game Cons</a></li>
    <li><a href="https://www.reddit.com/r/BoardgameDesign/">Board Game Design</a></li>
    <li><a href="https://www.reddit.com/r/gamedesign/">Game Design (mostly video game designers here)</a></li>
    </ul>
    
    <h3>Others</h3>
    
    <ul>
    <li><a href="https://www.thegamecrafter.com/announcements">The Game Crafter Community Announcements</a></li>
    <li>Your mailing list of previous attendees</li>
    <li>Ask your attendees to spread the word through their social media connections</li>
    <li><a href="https://boardgamegeek.com/forum/32/boardgamegeek/conventions">Board Game Geek Conventions Forum</a></li>
    <li><a href="http://www.bgdf.com/forums/general/announcements-press-releases">BGDF Announcements</a></li>
    </ul>
    
    <h2>Make contact at least 2 months before your event</h2>
    
    <ul>
    <li>Reach out to local game stores in your area</li>
    <li>Go to the Protospiels that come before yours and talk to attendees and ask if you can leave fliers there</li>
    <li>Local Universities and colleges. You'll want to get on their calendars, as well as see if they have game design in their curriculum.</li>
    </ul>
    
    <h2>Post at least weekly</h2>
    
    <ul>
    <li>Your own social media channels (Twitter, Facebook, Google+)</li>
    <li>Your blog</li>
    </ul>
    
    <h2>Post one week before your event</h2>
    
    <ul>
    <li><a href="http://craigslist.org">Craigslist</a> - In the Community &gt; Events section of your city's version of Craigslist.</li>
    </ul>
    
    <h2>Logo</h2>
    
    <p>You can use the official Protospiel logo in your marketing.</p>
    
    <p><img src="../assets/logo.png" alt="protospiel logo" class="img-fluid"/></p>
    
    <ul>
    <li><a href="https://www.dropbox.com/s/c6njfid0xagaczy/logo.ai?dl=0">Adobe Illustrator</a></li>
    <li><a href="https://www.dropbox.com/s/bju8p0x6pt8xe6h/logo.png?dl=0">PNG</a></li>
    <li><a href="https://www.dropbox.com/s/m2r52w65koiadxw/logo.svg?dl=0">SVG</a></li>
    </ul>
    </div>
</template>
